import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SpacedForwardSlash } from '@mews-commander/ui';
import { ModalLink } from '../../../../../components';

interface UnassignedBillLinkProps {
    url: string;
}

export const UnassignedBillLink: React.FC<UnassignedBillLinkProps> = ({ url }) => (
    <ModalLink url={url}>
        <LocalizedText textKey={TextKey.UnpaidBillItems} />
        {SpacedForwardSlash}
        <LocalizedText textKey={TextKey.DepositPlural} />
    </ModalLink>
);
